import validators from 'utils/forms/validators';

const serializeForm = (formValues, fields, initialData = {}) => {
    let dataToSubmit = {};

    fields.forEach(field => {
        let value = formValues[field.name];

        if (field.type === 'checkBox') {
            value = !!value;
        } else if (field.type === 'number' && value) {
            value = parseFloat(value);
        }

        if (field.transformation) {
            value = field.transformation(value);
        }

        if (field.extra) {
            const slug = field.name.replace('extra_', '');

            if (!dataToSubmit.extra) {
                dataToSubmit.extra = {};
            }

            dataToSubmit.extra[slug] = value;
        } else if (formValues[field.name] !== initialData[field.name]) {
            dataToSubmit[field.name] = value;
        }
    });

    return dataToSubmit;
};

const formInitialDataExtractor = (model, fields) => {
    const initialValues = {};

    fields.forEach(field => {
        let value = model[field.name];
        if (field.extra) {
            const slug = field.name.replace('extra_', '');
            value = model.extra?.[slug];
        }
        initialValues[field.name] = value;
    });

    return initialValues;
};

const metadataFields = (metadataList = [], _model = {}) => {
    return metadataList.map(metadata => {
        let componentRenderer = 'text', formData;

        if (metadata.type === 'boolean') {
            componentRenderer = 'checkBox';
        } else if (metadata.type === 'integer' || metadata.type === 'float') {
            componentRenderer = 'number';
        } else if (metadata.type === 'enumerator') {
            componentRenderer = 'select';
            formData = metadata.enumerator_members.map(member => ({ id: member, name: member }));
        }

        let name = metadata.name;
        if (metadata.slug === 'normally_closed') {
            name = 'Normally Closed (only applies to old WiseBoxes)';
        }
        let field = {
            description: metadata.description,
            extra: true,
            label: `${name}\x2a`,
            name: `extra_${metadata.slug}`,
            type: componentRenderer
        };

        if (formData) {
            field.formData = formData;
        }

        if (metadata.type !== 'boolean') {
            field.validate = [validators.required];
        }

        if (metadata.type === 'integer' || metadata.metadata_type === 'float') {
            field.validate.push(validators.number);
        }

        return field;
    });
};

export {
    formInitialDataExtractor,
    serializeForm,
    metadataFields
};
